import { JoinedFormFieldProps, CurrentUser } from 'types';
import { SocialSignUpBlock } from 'components/SocialBlock';
import { HorizontalDivider } from 'components/HorizontalDivider';
import {
  PASSWORD_CONFIRMATION_ERROR_NOTIFICATION,
  SIGN_UP_DESCRIPTION,
  SIGN_UP_HEADER,
  TO_EASY_PASSWORD_NOTIFICATION,
  WRONG_EMAIL_NOTIFICATION,
} from 'consts';
import { getEmailErrorMessage, getPasswordErrorMessage } from 'utils/validators';

export const getSignUpInitialFields = (user: CurrentUser, redirect?: string, email?: string): Array<JoinedFormFieldProps> => [
  {
    type: 'title',
    fieldName: 'title',
    value: SIGN_UP_HEADER,
  },
  {
    type: 'description',
    fieldName: 'value',
    value: SIGN_UP_DESCRIPTION,
  },
  {
    type: 'notification',
    fieldName: 'apiError',
  },
  ...(!email ? [{
    type: 'component',
    fieldName: 'social',
    child: <SocialSignUpBlock redirect={redirect} />,
  },
  {
    type: 'component',
    fieldName: 'div1',
    child: <HorizontalDivider caption="or" />,
  },
  {
    type: 'email',
    fieldName: 'email',
    placeholder: 'Email',
    required: true,
    value: email || (user?.registration_step ? user?.email : ''),
    errorMessage: WRONG_EMAIL_NOTIFICATION,
    validator: getEmailErrorMessage,
  }] : []),
  {
    type: 'password',
    fieldName: 'password',
    placeholder: 'Password',
    required: !user?.email,
    isDisabled: !!user?.email,
    errorMessage: TO_EASY_PASSWORD_NOTIFICATION,
    validator: getPasswordErrorMessage,
  },
  {
    type: 'password',
    fieldName: 'password_confirmation',
    placeholder: 'Confirm Password',
    required: !user?.email,
    isDisabled: !!user?.email,
    errorMessage: PASSWORD_CONFIRMATION_ERROR_NOTIFICATION,
    validator: getPasswordErrorMessage,
  },
];
